export const SAVE_ALL_SERVICE_OBSERVATIONS = 'SAVE_ALL_SERVICE_OBSERVATIONS'